import { render, staticRenderFns } from "./popup-comm.vue?vue&type=template&id=4e24b58a&scoped=true&"
import script from "./popup-comm.vue?vue&type=script&lang=js&"
export * from "./popup-comm.vue?vue&type=script&lang=js&"
import style0 from "./popup-comm.vue?vue&type=style&index=0&id=4e24b58a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e24b58a",
  null
  
)

export default component.exports